var PriceUtils = /** @class */ (function () {
    function PriceUtils() {
    }
    PriceUtils.prefixDecimalPart = function (price, language) {
        var comma = language === 'en' ? '.' : ',';
        return price ? comma + price : undefined;
    };
    return PriceUtils;
}());
export { PriceUtils };
